import React from 'react'
import { AppPage } from 'api'

interface SelectedItem {
	type: string
	field: string
}

interface AppPageLayoutDesigerContext {
	view: string
	chgView: (view: string) => void
	currSelectd: SelectedItem
	setCurrSelected: (currSelectd: SelectedItem) => void
	appPage: AppPage
	setAppPage: (appPage: AppPage) => void
}

export const AppPageLayoutDesigerContext = React.createContext<AppPageLayoutDesigerContext>(
	{} as AppPageLayoutDesigerContext
)



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageLayoutDesiger/AppPageLayoutDesigerContext.tsx